export function getFormatTime(timer) {
    // 转为正常的时间格式 年-月
    if (timer) {
        const time = timer.replace(/-/g,"/");
        let T_pos = time.indexOf('T');
        let Z_pos = time.indexOf('Z');
        let year_month_day = time.substr(0,T_pos);
        let hour_minute_second = time.substr(T_pos+1,Z_pos-T_pos-1).substr(0,8);
        let new_datetime = year_month_day+" "+hour_minute_second; // 2017-03-31 08:02:06
        // 处理成为时间戳
        timestamp = new Date(Date.parse(new_datetime));
        timestamp = timestamp.getTime();
        timestamp = timestamp/1000;
        // 增加8个小时，北京时间比utc时间多八个时区
        let timestamp = timestamp+8*60*60;
        let date = new Date(parseInt(timestamp) * 1000);
        // 时间戳转为时间
        let Y = date.getFullYear() + '.';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        return Y + M;
    }
    return timer;
}

export function getOverdue(timer) {
    // 判断活动是否过期
    if (timer) {
        const time = timer.replace(/-/g,"/");
        let T_pos = time.indexOf('T');
        let Z_pos = time.indexOf('Z');
        let year_month_day = time.substr(0,T_pos);
        let hour_minute_second = time.substr(T_pos+1,Z_pos-T_pos-1).substr(0,8);
        let new_datetime = year_month_day+" "+hour_minute_second; // 2017-03-31 08:02:06
        // 处理成为时间戳
        let timestamp = new Date(Date.parse(new_datetime));
        timestamp = timestamp.getTime();
        timestamp = timestamp/1000;
        // 增加8个小时，北京时间比utc时间多八个时区
        timestamp = timestamp+8*60*60;
        return timestamp * 1000 > new Date().getTime();
    }
    return timer;
}

export function getCompleteTime(timer) {
    // 转为正常的时间格式 年-月-日 时:分:秒
    if(timer && timer.indexOf('T') !== -1) {
        let timeStart=timer.substr(0,10);
        let timeEnd=timer.substr(11,8);
        const time = timer.replace(/-/g,"/");
        let T_pos = time.indexOf('T');
        let Z_pos = time.indexOf('Z');
        let year_month_day = time.substr(0,T_pos);
        let hour_minute_second = time.substr(T_pos+1,Z_pos-T_pos-1).substr(0,8);
        let new_datetime = year_month_day+" "+hour_minute_second; // 2017-03-31 08:02:06
        // 处理成为时间戳
        timestamp = new Date(Date.parse(new_datetime));
        timestamp = timestamp.getTime();
        timestamp = timestamp/1000;
        // 增加8个小时，北京时间比utc时间多八个时区
        let timestamp = timestamp+8*60*60;
        let date = new Date(parseInt(timestamp) * 1000);
        // 时间戳转为时间
        let Y = date.getFullYear() + '-'
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
        let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D + h + m + s;
    }
    return timer;
}

export function getTimeStr(date) {
    // 返回 HH:mm 格式
    if (!date) return "";
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

export function getRelativeTime(date) {
    // 返回相对时间格式：超过24小时显示 MM/DD，否则显示 HH:mm，60秒内显示"刚刚"
    if (!date) return "";
    const d = new Date(date);
    const now = new Date();
    const diff = now - d;

    if (diff > 24 * 60 * 60 * 1000) {
        return `${d.getMonth() + 1}/${d.getDate()}`;
    }

    if (diff > 60 * 1000) {
        return getTimeStr(d);
    }

    return "刚刚";
}


// WEBPACK FOOTER //
// ./src/utils/tools.js